/**
 * Real Stripe integration via backend proxy.
 */
export const stripeService = {
  /**
   * Calls the backend API to create a Stripe Checkout Session
   */
  createCheckoutSession: async (tenantId: string, planId: string): Promise<{ url: string }> => {
    const response = await fetch('/api/stripe/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ tenantId, planId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.details || 'Failed to create checkout session');
    }

    return response.json();
  },

  /**
   * Reports the latest user count for metered billing
   */
  reportUserUsage: async (tenantId: string): Promise<{ success: boolean; count: number }> => {
    const response = await fetch('/api/stripe/report-usage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ tenantId }),
    });

    if (!response.ok) {
      throw new Error('Failed to report usage');
    }

    return response.json();
  },

  // Note: Subscription status is handled by firestore listeners/hooks, 
  // not directly by Stripe JS on the client.
  
  /**
   * Fetches subscription status directly from Stripe
   */
  getSubscriptionStatus: async (tenantId: string): Promise<any> => {
    const response = await fetch(`/api/stripe/subscription-status/${tenantId}`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch subscription status');
    }

    return response.json();
  },
};
